/**
 * Map Constants
 * Centralized constants for map operations, layer IDs, source IDs, and icon paths
 */

// Layer ID Prefixes
export const LAYER_PREFIXES = {
  VESSELS: 'Vessels Layer -',
  VESSELS_CLUSTER: 'Vessels Layer - Cluster Layer -',
  VESSELS_CLUSTER_COUNT: 'Vessels Layer - Cluster Count -',
  VESSELS_SOURCE: 'Vessels Source -',
  SELECTED_GEOFENCE: 'selected-geofence',
  SELECTED_GEOFENCE_FILL: 'selected-geofence-fill',
  SELECTED_GEOFENCE_OUTLINE: 'selected-geofence-outline',
  INCIDENTS: 'Incidents Layer',
  PORTS: 'Ports Layer',
  RULER_POINTS: 'ruler-point-markers-layer',
  RULER_LINE: 'ruler-line-layer',
} as const;

// Source ID Prefixes
export const SOURCE_PREFIXES = {
  VESSELS: 'Vessels Source -',
  SELECTED_GEOFENCE: 'selected-geofence',
  RULER_POINTS: 'ruler-point-markers',
  RULER_LINE: 'ruler-line',
} as const;

// Icon Paths
export const ICON_PATHS = {
  VESSELS: '/vessels/',
  VESSEL_TYPES: [
    'cargo',
    'tanker',
    'passenger',
    'other_type',
    'reserved_for_future_use',
    'wing_in_ground',
    'high_speed_craft',
    'unknown_type',
  ] as const,
} as const;

// Layer Order (for insertion points)
export const LAYER_ORDER = {
  BEFORE_LABELS: 'before-labels',
  BEFORE_SYMBOLS: 'before-symbols',
} as const;

// Polygon Styles
export const POLYGON_STYLES = {
  FILL_COLOR: '#3b82f6',
  FILL_OPACITY: 0.2,
  OUTLINE_COLOR: '#60a5fa',
  OUTLINE_WIDTH: 2.5,
} as const;

// Vessel Layer Config
export const VESSEL_LAYER_CONFIG = {
  CLUSTER_MAX_ZOOM: 3,
  CLUSTER_RADIUS: 40,
  MIN_ZOOM: 4,
  CLUSTER_COLORS: {
    DEFAULT: '#6b6e64',
    SMALL: '#3b82f6',
    LARGE: '#3b82f6',
  },
  CLUSTER_THRESHOLDS: {
    SMALL: 10,
    LARGE: 50,
  },
  CLUSTER_RADIUS_SIZES: {
    DEFAULT: 7,
    MEDIUM: 17,
    LARGE: 27,
  },
} as const;

// Map Animation Config
export const MAP_ANIMATION = {
  FIT_BOUNDS_PADDING: 100,
  FIT_BOUNDS_DURATION: 1500,
  FIT_BOUNDS_MIN_ZOOM: 4,
  FIT_BOUNDS_MAX_ZOOM: 10,
} as const;

// Icon Size Interpolation
export const ICON_SIZES = {
  VESSEL: {
    MIN_ZOOM: 0,
    MAX_ZOOM: 5,
    MIN_SIZE: 0.03,
    MAX_SIZE: 0.06,
  },
} as const;
